// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../graphql/api/index';

import { gql } from 'graphql-tag';
export const JewelleryLinkFragmentDoc = gql`
    fragment jewelleryLink on CatalogueJewellery {
  __typename
  slug
  suffixSlug
  primaryMetal {
    systemCode
  }
}
    `;